import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=e15023e6&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=e15023e6&prod&lang=scss"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=e15023e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15023e6",
  null
  
)

export default component.exports